import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { DocumentApprovalStatus } from '../types';

interface StatusChipProps {
  status: DocumentApprovalStatus;
}

const statusColors: Record<DocumentApprovalStatus, 'warning' | 'success' | 'error' | 'default'> = {
  pending: 'warning',
  approved: 'success',
  rejected: 'error',
  expired: 'default',
};

const StatusChip: React.FC<StatusChipProps> = ({ status }) => {
  const { t } = useTranslation();
  const color = statusColors[status] ?? statusColors.pending;
  return <Chip label={t(`status.${status}`)} color={color} size="small" />;
};

export default StatusChip;
